export default function decodeQuery(query: string) {
  return decodeURIComponent(query);
}
